module.exports = __webpack_public_path__ + "img/shell_logo.3b65f908.svg";